<!--
// app/components/pages/region-news/GridRelatedNews.vue
-->
<script setup lang="ts">
import type { NitroFetchOptions } from "nitropack";
import type { Post, PostsResponse } from "~/src/post/domain/models/Post";
import BaseNuxtLink from "~/app/components/base/baseNuxtLink.vue";
import postUiService from "~/src/post/infrastructure/ui-services/postUiService";
import { $RELATED_NEWS_ITEMS } from "~/src/post/domain/service/PostService";
import { useWebContext } from "~/app/composables/webContext";
import CardNewsArticle from "~/app/components/Shared/news/CardNewsArticle.vue";

type Props = {
  categories?: number[];
  exclude?: number[];
};
const props = defineProps<Props>();

const { contextSiteTitle } = useWebContext();
const { getPosts } = postUiService();
const localePath = useLocalePath();
const route = useRoute();
const { locale, t } = useI18n();
const posts = ref<PostsResponse | undefined>();
const pageNum = ref<number>(1);

const initialOpts: NitroFetchOptions<any> = {
  params: {
    per_page: $RELATED_NEWS_ITEMS,
    page: pageNum.value,
    lang: locale.value,
  },
};

if (props.categories) {
  initialOpts.params.categories =
    props.categories.length > 1 ? props.categories.join(",") : props.categories[0].toString();
}

if (props.exclude) {
  initialOpts.params.exclude =
    props.exclude.length > 1 ? props.exclude.join(",") : props.exclude[0].toString();
}

posts.value = await getPosts(initialOpts);

pageNum.value++;
</script>

<template>
  <div v-if="posts && posts.data.length" class="px-5 mt-16">
    <p class="kql-page-section-title">
      {{ $t("news.post.relatedNews") }}
    </p>
    <hr />

    <div>
      <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 mt-12 mx-auto max-w-[1440px]">
        <card-news-article v-for="post in posts.data" :post="<Post>post" :key="post.id"></card-news-article>
      </div>
      <div class="py-6 flex justify-center items-center">
        <base-nuxt-link
          :to="
            localePath({
              name: 'region-news',
              params: { region: route.params.region, news: $t('general.news.word') },
            })
          "
          text-size="text-xs"
          primary
          >{{ $t("news.post.viewAllNews") }}</base-nuxt-link
        >
      </div>
    </div>
  </div>
</template>

<style scoped></style>
